export default "__VITE_ASSET__Dm1EHL_I__"